
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("aQ4z0"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("aQ4z0", function(module, exports) {

let $7e424cf69baf95cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e424cf69baf95cc$var$load("jPAfq"),
    $7e424cf69baf95cc$var$load("ennNB"),
    $7e424cf69baf95cc$var$load("9Hr92"),
    $7e424cf69baf95cc$var$load("g7Yjk"),
    $7e424cf69baf95cc$var$load("aqs28"),
    $7e424cf69baf95cc$var$load("7I4uK"),
    $7e424cf69baf95cc$var$load("hUbK8"),
    $7e424cf69baf95cc$var$load("22tb1"),
    $7e424cf69baf95cc$var$load("kGZ8W"),
    $7e424cf69baf95cc$var$load("8yk9S"),
    $7e424cf69baf95cc$var$load("iOfkQ"),
    $7e424cf69baf95cc$var$load("5KHgm"),
    $7e424cf69baf95cc$var$load("211bN"),
    $7e424cf69baf95cc$var$load("blNQo"),
    $7e424cf69baf95cc$var$load("bRoHi"),
    $7e424cf69baf95cc$var$load("4M5us"),
    $7e424cf69baf95cc$var$load("hoo42"),
    $7e424cf69baf95cc$var$load("gft53"),
    $7e424cf69baf95cc$var$load("lPKve"),
    $7e424cf69baf95cc$var$load("dmzjI"),
    $7e424cf69baf95cc$var$load("f7eY1"),
    $7e424cf69baf95cc$var$load("kedWY"),
    $7e424cf69baf95cc$var$load("giX30"),
    $7e424cf69baf95cc$var$load("lUYNi"),
    $7e424cf69baf95cc$var$load("3UmlS"),
    $7e424cf69baf95cc$var$load("7SteV"),
    $7e424cf69baf95cc$var$load("4aKct"),
    $7e424cf69baf95cc$var$load("jqoep"),
    $7e424cf69baf95cc$var$load("iYvvi"),
    $7e424cf69baf95cc$var$load("eWXZF"),
    $7e424cf69baf95cc$var$load("kfGHh"),
    $7e424cf69baf95cc$var$load("lIiD7"),
    $7e424cf69baf95cc$var$load("bJbqV"),
    $7e424cf69baf95cc$var$load("hLB9K"),
    $7e424cf69baf95cc$var$load("le1z7"),
    $7e424cf69baf95cc$var$load("4xsdA"),
    $7e424cf69baf95cc$var$load("ea3NB"),
    $7e424cf69baf95cc$var$load("dxcsb"),
    $7e424cf69baf95cc$var$load("7qcPK"),
    $7e424cf69baf95cc$var$load("6wr18"),
    $7e424cf69baf95cc$var$load("59hV4"),
    $7e424cf69baf95cc$var$load("cGkFm"),
    $7e424cf69baf95cc$var$load("2jERw"),
    $7e424cf69baf95cc$var$load("b7144"),
    $7e424cf69baf95cc$var$load("3LYaV"),
    $7e424cf69baf95cc$var$load("ffEVr"),
    $7e424cf69baf95cc$var$load("do0Fh"),
    $7e424cf69baf95cc$var$load("jNr09"),
    $7e424cf69baf95cc$var$load("9xmQ5"),
    $7e424cf69baf95cc$var$load("ckVWI"),
    $7e424cf69baf95cc$var$load("9LDVS"),
    $7e424cf69baf95cc$var$load("kiMHu"),
    $7e424cf69baf95cc$var$load("7J1PC"),
    $7e424cf69baf95cc$var$load("446Ip"),
    $7e424cf69baf95cc$var$load("fwbNS"),
    $7e424cf69baf95cc$var$load("9TOep"),
    $7e424cf69baf95cc$var$load("bSSct"),
    $7e424cf69baf95cc$var$load("45r7q"),
    $7e424cf69baf95cc$var$load("hhss7"),
    $7e424cf69baf95cc$var$load("aAWLw"),
    $7e424cf69baf95cc$var$load("7EorR"),
    $7e424cf69baf95cc$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.b3300b50.js.map
